import type { SelectedBundleOption } from "@jti/magento";

import type { ProductType } from "@checkout/components/SummarySubscription/SummarySubscriptionItem/SummarySubscriptionItem";

export const getBundleQuantityCount = (
  bundleOptions?: SelectedBundleOption[] | undefined,
  productType?: ProductType
): number => {
  if (!bundleOptions) {
    return 1;
  }

  return bundleOptions.reduce((total: number, bundleOption: SelectedBundleOption) => {
    const shouldIncludeInBundleQuantity = productType === "bundle" || bundleOption.type === "multi";
    if (!shouldIncludeInBundleQuantity) {
      return total;
    }

    const { values = [] } = bundleOption;
    const numberOfItemsForSingleProduct = values.reduce((subTotal: number, product) => subTotal + product.quantity, 0);

    return total + numberOfItemsForSingleProduct;
  }, 0);
};
